<template>
  <div class="dp-flex wrap justify-content__center">
    <div class="column">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  const wrapper = {
    name: "DpWrapper"
  };

  export default wrapper;
</script>

<style scoped>
  .column {
    max-width: 1200px;
    padding: 0 1rem;
    width: 100%;
  }
</style>
